import React from 'react';
import PropTypes from 'prop-types';

import './slideshow.styl'
class Slideshow extends React.Component {
    static propTypes = {
        className: PropTypes.string,
        label: PropTypes.string,
        images: PropTypes.array
    }

    static defaultProps = {
        images: []
    }

    className = this.props.className ? ' '+ this.props.className : ''

    slides = []
    demo = []
    caption = {}

    slideIndex = 1;

    plusSlides = n => this.showSlides(this.slideIndex += n);
    currentSlide = n => this.showSlides(this.slideIndex = n);
    showSlides = n => {
        const slides = this.slides;
        const dots = this.demo
        const captionText = this.caption
        if (n > slides.length) {this.slideIndex = 1}
        if (n < 1) {this.slideIndex = slides.length}

        slides.map(slide => slide.style.display = "none")
        dots.map(dot => dot.className = dot.className.replace(" active", ""))

        slides[this.slideIndex-1].style.display = "block";
        dots[this.slideIndex-1].className += " active";
        captionText.innerHTML = dots[this.slideIndex-1].alt;
    }

    render = () => <div className={'slideshow' + this.className} ref="slideshow">

        {this.props.images.map((img, i) => <div className={this.slideIndex===i ? '' : 'hide'} key={'slideshow-big-' + i} ref={r => this.slides.push(r)}>
            <div className="numbertext">{i} / {this.props.images.length}</div>
            <img src={img.src} />
        </div>)}

        <a className="prev" onClick={() => this.plusSlides(-1)}>&#10094;</a>
        <a className="next" onClick={() => this.plusSlides(1)}>&#10095;</a>

        <div className="caption-container">
            {this.props.description}
        </div>

        <ul className="slideshow-mini">
            {this.props.images.map((img, i) => <li key={'slideshow-mini-' + i}>
                <img src={img.src} onClick={() => this.currentSlide(i)} alt={img.alt} ref={r => this.demo.push(r)} />
            </li>)}
        </ul>

    </div>

}

export default Slideshow